/* eslint-disable */

/**
 * 这个已经关闭了，跳转到新的后台去。 道法自然~
 */
let url = window.location.href;
console.log("url", url);
let domain = "zg";
let www = "http://canteen.hbzgyc.com";
let id = 0;

var reg = RegExp(/http.*?\/\/(.*?)\./gi);
let ids = reg.exec(url);
if (ids !== null) {
  console.log("id", id);
  id = ids[1];
}

//判断域名
if (url.search("hbzgyc.com") == -1) {
  domain = "dy";
  www = "http://canteen.hbzgyc.com";
  // url = "http://st0001.deyicy.com/pc-manage/"; //test
}
let newUrl = www + "/?id=" + id + "&domain=" + domain;

// console.log("最终跳转的url------>", newUrl);
location.href = newUrl;

/**
 * 这个已经关闭了，跳转到新的后台去。 道法自然~
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import VueRouter from "vue-router";
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'

import { isBlank } from "./utils/is_blank"; // 判断值为空
import { isExist } from "./utils/is_exist"; // 判断值是否在数组对象中存在
import { accMul } from "./utils/acc_mul"; // 乘法精度问题
import { formatRouter } from "./utils/formatRouter"; // 格式化菜单树
import { setProductImg } from "./utils/setProductImg";
import "./assets/css/common.css"; // 公共样式
import "./assets/icon/iconfont.css"; // 字体图标库
import customLocalStorage from "store"; // store.js 跨浏览器的本地存储工具库
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import VueContextMenu from "vue-contextmenu";
import "v-charts/lib/style.css";
import VCharts from "v-charts";
import JsonViewer from "vue-json-viewer";

Vue.prototype.is_blank = isBlank;
Vue.prototype.setProductImg = setProductImg;
Vue.prototype.is_exist = isExist;
Vue.prototype.acc_mul = accMul;
Vue.prototype.customLocalStorage = customLocalStorage;
Vue.prototype.$store = store;
Vue.prototype.imgCanteenHost = "";
Vue.prototype.imgSupplierHost = "https://3c-supplier-t.deyicy.com/";
Vue.prototype.imgCentralHost = "https://3c-central.deyicy.com/";
Vue.use(VueQuillEditor);
Vue.use(VueContextMenu);
Vue.use(VCharts);
Vue.use(JsonViewer);
// 注册全局插件
Vue.use(ElementUI, { zIndex: 1000 }); // 修改弹框默认层级
Vue.use(VueRouter);

// 图片控件
// Vue.use(Viewer)

// 按扭权限指令
Vue.directive("allow", {
  inserted: (el, binding, vnode) => {
    let permissionList = vnode.context.$route.meta.permission;
    console.log("permissionList", permissionList);
    if (!permissionList.includes(binding.value)) {
      el.parentNode.removeChild(el);
    }
  }
});
// 解决在使用Element UI 时点击同一个路由，控制台报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
// 拦截未登录
router.beforeEach((to, from, next) => {
  const canteenPCToken = customLocalStorage.get("canteenPCToken")
    ? customLocalStorage.get("canteenPCToken")
    : null;
  if (to.path === "/login") {
    next();
  } else {
    if (canteenPCToken === null || canteenPCToken === "null") {
      next({
        path: "/login"
      });
    } else {
      Vue.prototype.imgCanteenHost = customLocalStorage.get("canteenPCHost");
      if (store.state.authTree.length === 0) {
        // 如果没有权限列表，将重新向后台请求一次
        // router.options.routes[1] = []
        store
          .dispatch("getAuthTree")
          .then(res => {
            let dataList = res.map(item => {
              return item;
            });
            // 调用权限匹配的方法
            // 将匹配出来的权限列表进行addRoutes
            router.options.routes.splice(1, 1, formatRouter(dataList));
            router.addRoutes(router.options.routes);
            console.log("动态路由：", router);
            if (from.path === "/login") {
              next({
                path: router.options.routes[1].redirect
              });
            } else {
              next(to.path);
            }
          })
          .catch(() => {
            router.replace("/").catch(err => err);
          });
      } else {
        if (to.matched.length) {
          next();
        } else {
          router.replace("/").catch(err => err);
        }
      }
    }
  }
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js